import { Component, OnDestroy, OnInit, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-testimonials',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss']
})
export class TestimonialsComponent implements OnInit, OnDestroy {
  currentIndex = 0;
  totalSlides = 4; // 4 testimonials in HTML
  visibleItems = 3;
  private autoPlayTimer: any;

  ngOnInit() {
    this.updateVisibleItems();
    this.startAutoPlay();
  }

  ngOnDestroy() {
    this.stopAutoPlay();
  }

  @HostListener('window:resize')
  onResize() {
    this.updateVisibleItems();
  }

  updateVisibleItems() {
    if (typeof window !== 'undefined') {
      if (window.innerWidth < 768) {
        this.visibleItems = 1;
      } else if (window.innerWidth < 1024) {
        this.visibleItems = 2;
      } else {
        this.visibleItems = 3;
      }
    }
    // Ensure currentIndex is within bounds after resize
    const maxIndex = this.totalSlides - this.visibleItems;
    if (this.currentIndex > maxIndex) {
      this.currentIndex = Math.max(0, maxIndex);
    }
  }

  startAutoPlay() {
    this.autoPlayTimer = setInterval(() => {
      this.nextSlide();
    }, 5000);
  }

  stopAutoPlay() {
    if (this.autoPlayTimer) {
      clearInterval(this.autoPlayTimer);
    }
  }

  nextSlide() {
    const maxIndex = this.totalSlides - this.visibleItems;
    if (this.currentIndex >= maxIndex) {
      this.currentIndex = 0; // Loop back to start
    } else {
      this.currentIndex++;
    }
  }

  prevSlide() {
    const maxIndex = this.totalSlides - this.visibleItems;
    if (this.currentIndex <= 0) {
      this.currentIndex = maxIndex; // Loop to end
    } else {
      this.currentIndex--;
    }
  }

  manualNext() {
    this.stopAutoPlay();
    this.nextSlide();
    this.startAutoPlay();
  }

  manualPrev() {
    this.stopAutoPlay();
    this.prevSlide();
    this.startAutoPlay();
  }
}
